import { Config } from "interfaces/Configs";
import { useMemo } from "react";
import { Select } from "ui/Form/Select";

import { ConfigData } from ".";

interface ContainerSlotsProps {
  config: Config;
  configIndex: number;
  selectedValues: Record<string, ConfigData[]>;
  selectOptions: { label: string; value: string }[];
  onValueChange: ({
    configId,
    containerId,
    newSlotId,
  }: {
    configId: string;
    containerId: string;
    newSlotId: string;
  }) => void;
}

const ContainerSlots = ({
  config,
  configIndex,
  selectedValues,
  selectOptions,
  onValueChange,
}: ContainerSlotsProps) => {
  const selectedSlotIds = useMemo(
    () => selectedValues[config._id]?.map((item) => item.slotId) ?? [],
    [selectedValues, config._id],
  );

  const allSelectedSlotIds = useMemo(() => {
    return Object.values(selectedValues)
      .flat()
      .map((item) => item.slotId);
  }, [selectedValues]);

  const options = useMemo(
    () =>
      selectOptions.filter(
        (item) =>
          !selectedSlotIds.includes(item.value) &&
          !allSelectedSlotIds.includes(item.value),
      ),
    [selectOptions, selectedSlotIds, allSelectedSlotIds],
  );

  return (
    <div className="max-w-lg border-white border-2 rounded-md border-opacity-40 p-4 flex flex-col gap-4">
      <p className="font-semibold text-lg">{`Sesión ${configIndex + 1}`}</p>
      {config.containerSlots.length === 0 ? (
        <p className="text-lg font-semibold text-center">
          Esta configuración no cuenta con contenedores para vincular. Por
          favor, contáctese con el vendedor.
        </p>
      ) : (
        <div className="flex flex-col gap-4 max-h-[400px] pr-6 overflow-scroll h-full">
          {selectedValues[config._id]?.map((item, index: number) => {
            const value =
              selectOptions.find((option) => option.value === item.slotId) ||
              null;

            const number =
              config.containerSlots[index]?.containerId?.number || "";
            return (
              <div
                key={item.containerId}
                className="flex justify-around items-center gap-6"
              >
                <p className="text-lg font-semibold mb-4">{`Contenedor ${number}`}</p>
                <div className="w-72">
                  <Select
                    name={"test"}
                    options={[
                      ...(value?.value
                        ? [{ label: "Quitar casco", value: null }]
                        : options.length
                          ? []
                          : [
                              {
                                label: "No quedan cascos por asignar",
                                value: null,
                              },
                            ]),
                      ...options,
                    ]}
                    label=""
                    onChange={(e) =>
                      onValueChange({
                        configId: config._id,
                        containerId: item.containerId,
                        newSlotId: e.target.value,
                      })
                    }
                    value={value}
                    disableOptionMap
                  />
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default ContainerSlots;
